namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_app, {

		Enter: {
			padding: '2rem',
		},
		Register: {
			padding: '2rem',
		},

		Tokens: {
			align: {
				content: 'center',
			},
		},

		Tokens_label: {
			justify: {
				content: 'center'
			},
		},
		Process_monitor_toggle_icon: {
			width: '1.25rem',
			height: '1.25rem',
		},
		History_toggle_icon: {
			width: '1.25rem',
			height: '1.25rem',
		},

		Book: {
			Menu: {
				width: 'max-content',
				minWidth: '14rem',
				Body_content: {
					gap: '1.5rem',
				},
				Foot: {
					flex: {
						direction: 'column',
					},
					gap: '0.5rem',
					padding: {
						left: '1.5rem',
						right: '1.5rem',
						bottom: '1rem',
					}
				},
				flex: {
					basis: 'auto',
				},
			},
		},

		Map_version: {
			position: 'fixed',
			bottom: 0,
			left: 0,
			margin: $mol_gap.block,
			maxWidth: $mol_style_func.calc( '100% - 7rem' ),
			zIndex: 6,
			background: { color: $mol_theme.back },
			textAlign: 'left',
			pointerEvents: 'none',
		},

		Right_bottom_panel: {
			background: {
				color: 'transparent',
			},
			flex: {
				direction: 'column',
			},
			gap: '11px',
			pointerEvents: 'none',
			'>': {
				'$mol_view': {
					pointerEvents: 'auto',
				},
			},
			align: {
				items: "flex-end",
			},
			position: 'fixed',
			bottom: 0,
			right: 0,
			margin: $mol_gap.block,
			zIndex: 6,
		},

		Speech: {
			margin: {
				bottom: '3.5rem',
			},
		},

		Main: {
			flex: {
				grow: 1,
			},
			Head: {
				justify: {
					content: 'flex-start',
				},
				align: {
					content: 'center',
				},
				padding: {
					top: 0,
					bottom: 0,
				},
			},
		},

		Profile: {

			margin: {
				left: 'auto',
			},
			
			Enter_link: {
				align: {
					items: 'center',
				},
			},
	
			Register_link: {
				align: {
					items: 'center',
				},
			},

		},
		
	} )
	
}
